// extracted by mini-css-extract-plugin
module.exports = {"PageBlock":"PageBlock_PageBlock__3c2LB","Title":"PageBlock_Title__3PLZf"};